import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';


export const passwordReset = (data) => {
    return (dispatch) => {
	return customRequest(actions.users.passwordReset, data).then((res) => {
	    return dispatch({ type: actions.users.passwordReset.status.success})
	})
    }
}

export const passwordUpdate = (data) => {
    
    return (dispatch) => {
	return customRequest(actions.users.passwordUpdate, data).then((res) => {
	    return dispatch({ type: actions.users.passwordUpdate.status.success})
	})
    }
}



// WEBPACK FOOTER //
// ./src/actions/Users.js